import { render, staticRenderFns } from "./noticeListPop.vue?vue&type=template&id=3aaf8f21&scoped=true"
import script from "./noticeListPop.vue?vue&type=script&lang=js"
export * from "./noticeListPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf8f21",
  null
  
)

export default component.exports